import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const ShipToPartyBodyWrapper = styled.div`
  .pane-sidebar-content {
    padding: 0 25px 25px;
  }
`;

export const CloseButton = styled.div`
  min-width: 24px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  border-radius: 8px;
  background: ${token('color.background.accent.gray.subtlest')};
  display: flex;
  align-items: center;
  justify-content: center;
`;
